import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue,
} from "react-hook-form";
import { ErrorText } from "../common.style";
import TextInputField from "../TextInputField";

export type InputFieldProps<TFieldValues extends FieldValues = FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues, any>;
  label: string;
  defaultValue?: string;
  type?: string;
  multiline?: boolean;
  rows?: number;
  onEnterHandle?: Function;
  id?: string;
  autoFocus?: boolean;
  inputLabelShrink?: boolean;
};

/** Primary UI component for input field */
const InputField = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  defaultValue,
  type,
  multiline,
  rows,
  id,
  autoFocus,
  inputLabelShrink,
}: InputFieldProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as PathValue<TFieldValues, Path<TFieldValues>>}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        const errorMessage = errors[name]?.message ?? null;
        return (
          <>
            {errorMessage && typeof errorMessage === "string" && (
              <ErrorText>{errorMessage}</ErrorText>
            )}
            <TextInputField
              onChange={onChange}
              label={label}
              value={value ?? defaultValue ?? ""}
              error={typeof errors[name]?.message !== "undefined"}
              type={type}
              multiline={multiline}
              rows={rows}
              id={id ?? undefined}
              autoFocus={typeof autoFocus !== "undefined" ? autoFocus : true}
              inputLabelShrink={inputLabelShrink}
            />
          </>
        );
      }}
    />
  );
};

export default InputField;
